import { useCallback } from 'react';
import {
  AnalyticsEventLabels,
  AnalyticsEventsMap,
  type TrackInteractionsEvent,
} from 'src/modules/analytics/useTrackAnalytics/domains/interactions/events';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';

/**
 * Custom hook to handle txm tracking events
 */
export function useTrackInteractionsAnalytics() {
  const trackEvent = useTrackEvent();
  return useCallback(
    (event: TrackInteractionsEvent, extra?: Record<string, unknown>) => {
      const eventLabel = AnalyticsEventLabels[event];
      const eventInfo = AnalyticsEventsMap[event];
      trackEvent(eventLabel, { ...eventInfo, ...extra });
    },
    [trackEvent],
  );
}
